import { FC } from 'react';
import { BoxProps, SvgIconProps } from '@material-ui/core';
import { MobileFloatMenu } from './components/menu-item/styled';
import { MenuItem } from './components';

interface Item {
  title: string;
  icon: FC<SvgIconProps>;
  count?: number;
  onClick: () => void;
}

interface FloatMenuProps {
  containerProps?: BoxProps;
  items: Item[];
}

export const FloatMenu = ({ items, containerProps }: FloatMenuProps) => (
  <MobileFloatMenu {...containerProps}>
    {items.map(({ title, icon, count, onClick }) => (
      <MenuItem
        key={title}
        title={title}
        Icon={icon}
        onClick={onClick}
        count={count}
      />
    ))}
  </MobileFloatMenu>
);
